module.exports = __webpack_public_path__ + "static/media/profile_bg.c6f56a53.png";